"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconLibrary = function IconLibrary(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    className: (0, _classnames.default)('Icon', 'IconLibrarys', className),
    style: style
  }, _react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.684 13.732a.91.91 0 1 1 .813 1.627l-9.09 4.545a.91.91 0 0 1-.814 0l-9.09-4.545a.91.91 0 0 1 .813-1.627L10 18.075zm0-4.545a.91.91 0 1 1 .813 1.626l-9.09 4.546a.91.91 0 0 1-.814 0l-9.09-4.546a.91.91 0 0 1 .813-1.626L10 13.529zM10.407.096l9.09 4.545a.91.91 0 0 1 0 1.627l-9.09 4.545a.91.91 0 0 1-.814 0L.503 6.268a.91.91 0 0 1 0-1.627L9.593.096a.91.91 0 0 1 .814 0zM10 1.926L2.942 5.454 10 8.984l7.058-3.53L10 1.926z"
  }));
};

var _default = IconLibrary;
exports.default = _default;